<div class="row m-0">
    <div class="col-12 pe-2">
        <div class="row m-0 p-0">
            <div class="col-5 ps-0 pe-2">
                <dp-filter-card [filterCard]="cpuFilterCard" [noResultsVisible]="false"
                    [showLoading]="showLoadingCpu" [subtitle]="cpuFilterCard.subtitle">
                    @if (cpuResult.length > 0 && lineChartCpu) {
                        <dp-chart ngProjectAs="body" [chart]="lineChartCpu"></dp-chart>
                    } @else {
                        <div ngProjectAs="body" class="d-flex h-100 w-100 justify-content-center align-items-center text-center px-3">
                            <h3 class="m-0 widget-title">{{ noResultsLabel }}</h3>
                        </div>
                    }
                </dp-filter-card>
            </div>
            <div class="col-5 px-2">
                <dp-filter-card [filterCard]="ramFilterCard" [noResultsVisible]="false"
                    [showLoading]="showLoadingRam" [subtitle]="ramFilterCard.subtitle" (filterChanged)="loadRamFilter($event)">
                    @if (ram.length > 0 && lineChartRam) {
                        <dp-chart ngProjectAs="body" [chart]="lineChartRam"></dp-chart>
                    } @else {
                        <div ngProjectAs="body" class="d-flex h-100 w-100 justify-content-center align-items-center text-center px-3">
                            <h3 class="m-0 widget-title">{{ noResultsLabel }}</h3>
                        </div>
                    }
                </dp-filter-card>
            </div>
            <div class="col-2 pe-0 ps-2">
                <dp-filter-card [filterCard]="diskFilterCard" [noResultsVisible]="false"
                    [showLoading]="showLoadingDisk" [subtitle]="diskFilterCard.subtitle">
                    @if (disk.length > 0 && pieChart) {
                        <dp-chart ngProjectAs="body" [chart]="pieChart"></dp-chart>
                    } @else {
                        <div ngProjectAs="body" class="d-flex h-100 w-100 justify-content-center align-items-center text-center px-2">
                            <h3 class="m-0 widget-title">{{ noResultsLabel }}</h3>
                        </div>
                    }
                </dp-filter-card>
            </div>
        </div>
    </div>
</div>
